<template>
  <section class="ren-decoration-cp ren-decoration-cp-scenic-lead-form">
    <strong>{{ title }}</strong>
    <span>姓名 / 手机号 / 意向</span>
    <button type="button">{{ submitButtonText }}</button>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const title = computed(() => stringValue(props.component.props?.title, '咨询预订'))
const submitButtonText = computed(() => stringValue(props.component.props?.submitButtonText, '提交'))
</script>

<style scoped>
.ren-decoration-cp-scenic-lead-form {
  display: grid;
  gap: 8px;
}
.ren-decoration-cp-scenic-lead-form span {
  color: var(--ren-theme-muted);
  font-size: 12px;
}
.ren-decoration-cp-scenic-lead-form button {
  justify-self: start;
  border: 0;
  border-radius: 6px;
  padding: 8px 12px;
  background: var(--ren-theme-primary);
  color: #fff;
}
</style>
